"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// brackets for bindings parser
var _default = {
  left: '{{',
  right: '}}'
};
exports["default"] = _default;
//# sourceMappingURL=parserbrackets.js.map